import type { NotificationType } from "./notifications"
import type { Translate } from "@/i18n"

/** Human readable action for each notification type. */
export function notificationLabel(t: Translate, type: NotificationType): string {
  switch (type) {
    case "mention":
      return t("mentioned you")
    case "reply":
      return t("replied to your note")
    case "reaction":
      return t("reacted to your note")
    case "repost":
      return t("reposted your note")
    case "follow":
      return t("followed you")
    default:
      return ""
  }
}
